<template>
    <div class='topnav-wrap'>
        <div class="topnav-item flc" :class="{'active-item':currentIndex == index}" v-for="(item,index ) in topnavList" :key="index" @click="topnacChange(index)">{{item.name}}</div>
    </div>
</template>
<script>


export default {
    name: "",

    // 组件注册
    components: {},
    data() {
        return {
        };
    },
    props: {
        currentIndex:{
            type:Number,
            default:0
        },
        topnavList:{
            type:Array,
            default() {
                return []
            }
        }
    },
    //计算属性
    computed: {},
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        topnacChange (index) {
            this.$emit('changeIndex',index)
        }
    },
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.topnav-wrap {
    width: 100%;
    height: 100%;
    padding: 0 60px 0;
    display: flex;
    justify-content: space-evenly;
    .topnav-item {
        width: 160px;
        height: 64px;
        background: #F3F6FF;
        border-radius: 80px 80px 80px 80px;
        font-size: 24px;
        font-weight: 400;
        color: #0D53FC;
        transition: all 0.4s;
    }
    .active-item {
        background: #0D53FC;
        color: #FFFFFF;
    }
}
</style>
